export default "__VITE_ASSET__34105965__"